import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
// import LoadServices from './js/services/loadServices'
// eslint-disable-next-line spaced-comment
/////////////////////////////////////////
/* eslint-disable no-unused-vars */
import bugsnag from '@/js/services/bugsnag-service'
// eslint-disable-next-line spaced-comment
//////////
import { get } from 'lodash-es'
import PortalVue from 'portal-vue'
import SVGStore from 'webpack-svgstore-plugin/src/helpers/svgxhr'

import appConfig from '@/js/helper/app-config-helper.js'

import { getVuetify } from '@/js/plugins/vuetify'
// import '@/styles/main.scss'
import '@/js/components/_globals'
import { getI18n } from '@/js/plugins/vue18i'
import { initWs } from '@/js/plugins/ws'
// import store from '@/js/plugins/store'
import { getStore } from '@/js/plugins/store'
import router from '@/js/plugins/router'
import { createGtm } from '@/js/plugins/tagManager'
import { featureApi } from '@/js/plugins/store/modules/app/featureApi.js'
import { setDefaultAxiosInterceptor } from '@/js/helper/axios-helper'

import { types as STORE_MODULES } from '@/js/plugins/store/store-modules'
import APP_ACTIONS from '@/js/plugins/store/modules/app/action-types'

import '@/styles/main.scss'

export default class App {
  constructor({ selector, options = {} }) {
    this.initSvgStore()
    this.initVue()
  }

  initSvgStore() {
    const __svg__ = { path: './svg/**/*.svg', name: '[hash].icons.svg' }
    this.svgStore = new SVGStore(__svg__)
  }

  initVue() {
////////////////////
//////////////////////////////
//////////////////////////////////////////////
//////////////

    Vue.use(VueCompositionAPI)

    const store = getStore(appConfig)
    const echo = initWs({ appConfig, store })

    getI18n(store).then(({ i18n }) => {
      Vue.prototype.$featureApi = featureApi
      Vue.prototype.$http = setDefaultAxiosInterceptor(store)

      const customerNumber = get(store, ['getters', 'app/USER', 'customerNumber'])

      window.addEventListener('cf_consent', function (event) {
        // console.log('cf_consent', event)
        store.dispatch(`${STORE_MODULES.APP}/${APP_ACTIONS.SET_APP_CONSENT}`, event.detail)
      })

      const gtm = createGtm({
        vueRouter: router,
        ignoredViews: ['login'],
        locale: i18n?.locale,
        customerNumber,
      })

      Vue.use(gtm)

      new Vue({
        i18n,
        store,
        router,
        vuetify: getVuetify({ i18n }),
      }).$mount('#app__wrapper')

      // Todo: test is unstyled content is hidden
      const appWrapper = document.querySelector('#app__wrapper')
      if (!appWrapper) {
        return
      }
      appWrapper.classList.remove('app__wrapper--show-loader')
    })

    Vue.use(PortalVue)
  }
}
